import { Injectable } from '@angular/core';

/**
 * Only used for CTI (b2e). It probably should be moved to b2e-utils, but currently used by rwc-utils-onprem as well.
 */
@Injectable({ providedIn: 'root' })
export class EventCorrelationIdService {
    private correlationId: string | undefined;

    get(): string | undefined {
        return this.correlationId;
    }

    set(id?: string): void {
        this.correlationId = id;
    }
}
